import { render, staticRenderFns } from "./TheSwitch.vue?vue&type=template&id=487937f5&scoped=true"
import script from "./TheSwitch.vue?vue&type=script&lang=ts"
export * from "./TheSwitch.vue?vue&type=script&lang=ts"
import style0 from "./TheSwitch.vue?vue&type=style&index=0&id=487937f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487937f5",
  null
  
)

export default component.exports